enum PerfisUsuario {
    Admin = 1,
    Padrao = 2,
    Franqueado = 3,
    Rede = 4,
    Suporte = 5,
}

export default PerfisUsuario;
